import { styled } from '@lichtblick/styled';

export const NoRolesContainer = styled.div`
  align-items: center;
  background: var(--colors-white);
  border-radius: var(--border-radius-xs);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-m);
  height: 100vh;
  justify-content: center;
  padding: var(--spacing-l) var(--spacing-m);
  width: 100%;
`;

export const NoRolesLink = styled.a`
  color: var(--colors-blue-100);
`;
